import { err, ok } from "neverthrow";
import { buildInvalidError } from "@thalamos/common";
export const isActive = (organisation) => organisation.status === "active";
export function mustBeActive(message = "Organisation must be active") {
    return (organisation) => isActive(organisation)
        ? ok(organisation)
        : err(buildInvalidError({ message }));
}
export const isCqc = (organisation) => organisation.role === "cqc";
export function mustBeCqc(message = "Organisation must be CQC") {
    return (organisation) => isCqc(organisation)
        ? ok(organisation)
        : err(buildInvalidError({ message }));
}
//# sourceMappingURL=organisation.predicates.js.map